import { ThemeProvider } from "@emotion/react";
import { ReactNode } from "react";
import { theme } from "../theme/theme";
import { AuthProvider } from "./AuthContext";
import { ErrorProvider } from "./ErrorContext";
import { RecordingOpportunityProvider } from "./RecordingOpportunityContext";

type AppProviderProps = {
  children: ReactNode;
};

export function AppProvider({ children }: AppProviderProps) {
  return (
    <ThemeProvider theme={theme}>
      <ErrorProvider>
        <AuthProvider>
          <RecordingOpportunityProvider>
            {children}
          </RecordingOpportunityProvider>
        </AuthProvider>
      </ErrorProvider>
    </ThemeProvider>
  );
}
